<template>
  <div class="add-user-box">
    <el-row class="user-item">
      <el-col :span="4">
        <i>*</i>入园人
        <el-input
          class="name"
          v-model="name"
          placeholder="请输入姓名"
        ></el-input>
      </el-col>
      <el-col :span="8">
        <i>*</i
        ><!--证件类型-->
        <el-select
          class="certificateType"
          v-model="contactIDTypeValue"
          placeholder="选择证件类型"
          @change="selectOne"
        >
          <el-option
            v-for="cItem in certificateTypeList"
            :key="cItem.value"
            :label="cItem.name"
            :value="cItem.value"
          >
          </el-option>
        </el-select>
        <el-input
          class="id idInput"
          v-model="id"
          placeholder="输入真实证件号凭证入园"
        ></el-input>
      </el-col>
      <el-col :span="5">
        <i>*</i>游客类型
        <el-radio-group
          class="radio"
          v-model="userType"
          text-color="#31a775"
          @change="userTypeChange"
        >
          <el-radio label="1">成人</el-radio>
          <el-radio label="2">儿童</el-radio>
        </el-radio-group>
      </el-col>
      <el-col :span="6" v-if="preferentialShow">
        <i>*</i>优惠类型
        <el-select
          class="preferential"
          v-model="preferentialVal"
          placeholder="请选择"
          @change="selectPre"
        >
          <el-option
            v-for="item in preferentialList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <div class="btn-list">
      <el-button type="primary" @click="addUser">确认</el-button>
      <el-button class="add-user-close" @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import ticket from '@/store/modules/ticket';
import constValuesConfig from '../setup/constantConfig';
import user from '../api/user';
import users from '../setup/user';
import { UUID, convertDateFromString } from '../setup/common';
import moment from 'moment';
import { regexs, checkIDNumber, IDNumberFilter } from '../setup/common';
/*import regexs from '../setup/regexs';*/
export default {
  name: 'AddUser',
  props: {
    ticket: Object,
    currentDate: String,
    startTime: String,
    endTime: String,
  },
  data() {
    return {
      name: '',
      id: '',
      userType: '1',
      certificateTypeList: constValuesConfig.ID,
      preferentialList: [],
      contactIDTypeValue: '', //证件类型
      contactIDTypeName: '', //证件名
      contactTypeValue: 0, //联系人类型
      preferentialVal: '', //优惠类型model
      preferentialShow: false, //是否显示优惠类型
      /*startTime: '',
      endTime: '',*/
    };
  },
  created() {
    if (this.ticket) {
      /*let timeStartStr = convertDateFromString(
        this.currentDate + ' ' + this.ticket.start_time,
      );
      let timeEndStr = convertDateFromString(
        this.currentDate + ' ' + this.ticket.end_time,
      );
      this.startTime = moment(timeStartStr).format('YYYYMMDDHHmm');
      this.endTime = moment(timeEndStr).format('YYYYMMDDHHmm');*/
      console.log('组件时间值', this.startTime, this.endTime);
      let preferentialListGet = JSON.parse(
        localStorage.getItem('customerType'),
      );
      for (const key in preferentialListGet) {
        if (preferentialListGet[key].ticket_type == this.ticket.ticket_type) {
          this.preferentialList = preferentialListGet[key].customer_type.split(
            ',',
          );
          this.preferentialShow = true;
        } /*else {
          this.preferentialShow = false;
        }*/
      }
    }
  },
  methods: {
    async addContact() {
      let currentUser = users.getUser();
      const contactData = await user.addContact({
        username: this.name,
        phone: currentUser.phone,
        certificate_type: this.contactIDTypeValue,
        certificate_id: this.id,
        contact_type: this.contactTypeValue,
      });
      //开始组装数据
      this.assembUserData();
    },
    selectOne(event) {
      this.contactIDTypeValue = event;
      this.certificateTypeList.forEach((item) => {
        if (item.value == this.contactIDTypeValue) {
          this.contactIDTypeName = item.name;
        }
      });
    },
    selectPre(event) {
      this.preferentialVal = event;
    },
    userTypeChange(event) {
      console.log('hahh', event);
      if (event == 1) {
        this.contactTypeValue = 0; //成人
      } else if (event == 2) {
        this.contactTypeValue = 1; //儿童
      }
    },
    addUser() {
      if (!this.name.length) {
        alert('请输入入园人姓名');
        return;
      }
      if (!this.contactIDTypeValue.length) {
        alert('请选择证件类型');
        return;
      }
      if (!this.id) {
        alert('请输入证件号码');
        return;
      }
      if (this.contactIDTypeValue == constValuesConfig.IDCode.ID) {
        if (!checkIDNumber(this.id)) {
          alert('请输入正确的身份证号码');
          return null;
        }
      } else if (this.contactIDTypeValue == constValuesConfig.IDCode.Passport) {
        if (!regexs.passport.test(this.id)) {
          alert('请输入正确的护照号码');
          return null;
        }
      } else if (
        this.contactIDTypeValue == constValuesConfig.IDCode.HMPassport
      ) {
        if (!regexs.HMPassport.test(this.id)) {
          alert('请输入正确的港澳通行证号码');
          return null;
        }
      } else if (
        this.contactIDTypeValue == constValuesConfig.IDCode.TPassport
      ) {
        if (!regexs.TWPassport.test(this.id)) {
          alert('请输入正确的台胞证号码');
          return null;
        }
      }
      this.addContact();
    },
    cancel() {
      this.$emit('childUser');
    },
    assembUserData() {
      let newUser = {};
      let newUsersArray = [];
      let currentUser = users.getUser();
      newUser.user_name = this.name;
      newUser.id_type = this.contactIDTypeValue;
      newUser.id_number = this.id;
      newUser.id = '1';
      newUser.key = '' + this.id + '_' + UUID();
      newUser.phone = currentUser.phone;
      if (this.preferentialShow) {
        newUser.contact_type = this.preferentialVal;
      } else {
        if (parseInt(this.contactTypeValue) == 0) {
          newUser.contact_type = '成人';
        } else if (parseInt(this.contactTypeValue) == 1) {
          newUser.contact_type = '儿童';
        }
      }
      newUser.custom_type = newUser.contact_type; //this.contactTypeValue;
      newUser.gender = '1';
      newUser.ticketType = this.ticket.ticket_type;
      let newTicket = {};
      newTicket.ticket_type = this.ticket.code;
      newTicket.use_time = this.startTime;
      newTicket.use_end_time = this.endTime;
      newTicket.ticketName = this.ticket.name;
      newTicket.price = this.ticket.price;
      newTicket.ticket_type_id = this.ticket.ticket_type;
      newTicket.uid = UUID();
      if (this.ticket.description) {
        newTicket.description = this.ticket.description;
      }
      let tickets = [];
      tickets.push(newTicket);
      newUser.tickets = tickets;
      newUsersArray.push(newUser);
      /*this.$store.dispatch('updateContactInfoGet', newUsersArray);*/
      this.$store.commit('updateContactInfo', newUsersArray);
      this.$emit('childUser');
    },
  },
};
</script>

<style scoped lang="less">
.add-user-box {
  /*display: none;*/
  padding-bottom: 8px;
}
.user-item {
  margin-bottom: 8px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  line-height: 52px;
  .el-col {
    box-sizing: border-box;
    margin-right: 10px;
    padding: 0;
    border-right: 1px solid #eee;
    color: #409eff;
    font-weight: bold;
    // font-size: 16px;
    text-align: left;
    i {
      margin-right: 8px;
      color: #f15b49;
    }
    span {
      margin-left: 16px;
      color: #31a775;
    }
    .name {
      width: 102px;
      margin-left: 2px;
    }
    .id {
      width: 262px;
      margin-left: 2px;
    }
    .idInput {
      width: 193px;
    }
    .radio {
      width: 125px;
      margin-left: 8px;
      .label {
        margin-right: 2px;
      }
    }
    .preferential {
      width: 180px;
      margin-left: 2px;
    }
    .certificateType {
      width: 130px;
    }
  }
  .el-col:last-child {
    margin: 0;
    border: 0;
  }
  /deep/.el-radio {
    margin-right: 8px;
  }
  // /deep/.el-radio__input.is-checked + .el-radio__label {
  //   color: #31a775 !important;
  // }
  // /deep/.el-radio__input.is-checked .el-radio__inner {
  //   border-color: #31a775 !important;
  //   background: #31a775 !important;
  // }
  /deep/.el-input input {
    color: #191b26;
    font-weight: bold;
  }
}
.btn-list {
  text-align: center;
}
</style>
